<!-- TEMPLATE -->
<template>
  <div class="wrapper">
    <dean-dialog
      title="Edit Sim Card Details"
      :large="false"
      :addClose="true"
      @close="close"
    >
      <slot name="load">

      </slot>
      <dean-notification :is-modal="true">

      </dean-notification>

      <fade-transition group>
        <div class="dean-form-row" key="sim-number-search-1">
          <div class="row" key="sim-number-search-2">
            <div class="small-6 medium-6 large-6 hd-6 columns">
              <p class="input-label">sim-nummer <span v-if="this.payloadData.odidoMobileProvisioningErrorCode === 'ERR_SIM_CARD_ACTIVATION_FAILED'" style="color:red">*</span></p>
            </div>
            <div class="small-6 medium-6 large-6 hd-6 columns">
              <div class="multiselect-wrapper" key="search">
                <multiselect id="ajax" track-by="code" :placeholder="placeholder" open-direction="bottom"
                             :options="options" :noOptions="noOptions" :selectLabel="selectLabel"
                             :show-labels="false" :searchable="true"
                             :disabled="disableSimCardField"
                             :internal-search="false" :clear-on-select="true" :close-on-select="true"
                             :options-limit="300" :limit="5" :max-height="600" :hide-selected="true"
                             @search-change="asyncFind" @select="simNumberSelected">
                  <template slot="option" slot-scope="props">
                    <div class="option__desc">
                      <div class="option__title">{{ props.option.simNumber }}</div>
                    </div>
                  </template>
                  <span slot="noResult">{{ noResult }}</span>
                  <span slot="noOptions">{{ noOptions }}</span>
                </multiselect>

              </div>
            </div>
          </div>
        </div>
      </fade-transition>

      <fade-transition group>
        <dean-form-row id="msisdn" label="msisdn" type="string" v-model="data.msisdn"
                       key="msisdn" :disabled="true"
                       :requiredField="this.portingFieldRequired()"
                       :warning="$v.data.msisdn.$error"></dean-form-row>
      </fade-transition>

      <fade-transition group>
        <dean-form-row id="klantnummer" label="klantnummer" type="string" v-model="data.customerNumber"
                       key="customerNumber" :disabled="disablePortingFields"
                       :requiredField="this.portingFieldRequired()"
                       :warning="$v.data.customerNumber.$error"></dean-form-row>
      </fade-transition>

      <fade-transition group>
        <dean-form-row id="msisdnToPort" label="porteren msisdn" type="string" v-model="data.msisdnToPort"
                       key="msisdnToPort" :disabled="disablePortingFields"
                       :requiredField="this.portingFieldRequired()"
                       :warning="$v.data.msisdnToPort.$error"></dean-form-row>
      </fade-transition>

      <date-input
          :label="portingWishDateLabel"
          :value="data.portingWishDate"
          :min-date="minimumDate"
          :requiredField="this.portingFieldRequired()"
          :disabled="disablePortingFields"
          :warning="$v.data.portingWishDate.$error"
          @dateValueChanged="dateValueChanged"></date-input>

      <dean-select-form-row id="contractafhandeling" label="contractafhandeling"
                            :value="selectedPortingContractHandligLabel"
                            @input="portingContractHandlingSelected"
                            :options="portingContractHandlingOptions"
                            :disabled="disablePortingFields"
                            :requiredField="this.portingFieldRequired()"
      ></dean-select-form-row>

      <span slot="dean-dialog-button-group">
        <dean-button :danger="true" :dialog-button="true" @click.native="close()">Annuleren</dean-button>
        <dean-button :success="true" :dialog-button="true" @click.native="save()">Versturen</dean-button>
      </span>
    </dean-dialog>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop, Watch} from 'vue-property-decorator';
import axios from 'axios';
import {
    // SVG
    warningIcon,
    // COMPONENTS
    deanDialog,
    deanDialogButtonGroup,
  } from '@deanone/dean-components';
import deanSelectFormRow from '@/components/deanComponents/deanSelectFormRow.vue';
import deanButton from '@/components/deanComponents/deanButton.vue';
import DeanNotification from '@/components/deanComponents/deanNotification.vue';
import deanFormRow from '@/components/deanComponents/deanFormRow.vue';
import {deanDialogBus} from '@/main';
import {validationMixin} from 'vuelidate';
import {requiredIf} from 'vuelidate/lib/validators';
import {Validations} from 'vuelidate-property-decorators';
import {createNotificationFromData, validationMessage} from '@/mixins/validations';
import {FadeTransition} from 'vue2-transitions';
import {getErrorCodeFromResponse} from "@/mixins/errorMessage";
import Multiselect from 'vue-multiselect';
import DateInput from '@/components/DateInput.vue';


@Component({
    components: {
      DateInput,
      Multiselect,
      warningIcon,
      DeanNotification,
      deanDialog,
      deanButton,
      deanFormRow,
      deanSelectFormRow,
      deanDialogButtonGroup,
      FadeTransition,
    },
    mixins: [validationMixin],
  })

  export default class EditSimCardDetailsDialog extends Vue {
  @Prop() public payloadData!: any;

  public timer: any = undefined;
  public options: any = [];
  public placeholder: any = this.payloadData.simNumber ?? 'Zoek simnummerkaart';
  public portingContractHandlingOptions = [
    {value: 'TERMINATE_ON_END_DATE', label: 'Beëindig het huidige contract op de einddatum'},
    {value: 'ALREADY_TERMINATED', label: 'Het huidige contract is reeds beëindigd'},
    {value: 'TERMINATE_PREMATURELY', label: 'Beëindig het huidige contract voortijdig'},
    {value: 'DO_NOT_TERMINATE', label: 'Het Huidige contract niet beëindigen'},
  ];

  @Validations()
  get validations() {
    const valData: any = {
      data: {
        msisdn: {
          required: requiredIf(() => {
            return this.payloadData.odidoMobileProvisioningErrorCode === 'ERR_SIM_CARD_ACTIVATION_FAILED';
          }),
        },
        simNumber: {
          required: requiredIf(() => {
            return this.payloadData.odidoMobileProvisioningErrorCode === 'ERR_SIM_CARD_ACTIVATION_FAILED';
          }),
        },
        customerNumber: {
          required: requiredIf(() => {
            return this.payloadData.odidoMobileProvisioningErrorCode === 'ERR_INVALID_PORTING_REQUEST';
          }),
        },
        msisdnToPort: {
          required: requiredIf(() => {
            return this.payloadData.odidoMobileProvisioningErrorCode === 'ERR_INVALID_PORTING_REQUEST';
          }),
        },
        portingWishDate: {
          required: requiredIf(() => {
            return this.payloadData.odidoMobileProvisioningErrorCode === 'ERR_INVALID_PORTING_REQUEST';
          }),
        },
        portingContractHandling: {
          required: requiredIf(() => {
            return this.payloadData.odidoMobileProvisioningErrorCode === 'ERR_INVALID_PORTING_REQUEST';
          }),
        },
      },
    };

    return valData;
  }

  public data: {[key: string]: any} = {
    msisdn: this.payloadData.msisdn,
    simNumber: this.payloadData.simNumber,
    customerNumber: this.payloadData.customerNumber,
    msisdnToPort: this.payloadData.msisdnToPort,
    portingWishDate: this.payloadData.portingWishDate,
    portingContractHandling: this.payloadData.portingContractHandling,
  };

  public check() {
    return false;
  }

  public close() {
    deanDialogBus.$emit('close');
  }

  get disableSimCardField()
  {
    if (this.payloadData?.odidoMobileProvisioningErrorCode === 'ERR_SIM_CARD_ACTIVATION_FAILED') {
      return false;
    }

    return true;
  }
  get disablePortingFields()
  {
    if (
        this.payloadData?.odidoMobileProvisioningErrorCode === 'ERR_INVALID_PORTING_REQUEST'
        ||
        this.payloadData?.odidoMobileProvisioningErrorCode === 'ERR_PORTING_REQUEST_FAILED'
    ) {
      return false;
    }

    return true;
  }

  get minimumDate() {
    return new Date();
  }

  get portingWishDateLabel() {
    return 'porteerwensdatum';
  }

  get noOptions() {
    return 'Voer minimaal drie cijfers in.';
  }

  get noResult() {
    return 'Geen resultaten gevonden.';
  }

  get selectLabel() {
    return 'Druk op enter om te kiezen';
  }

  public portingContractHandlingSelected(field: any) {
    this.data.portingContractHandling = field.value;
  }

  get selectedPortingContractHandligLabel() {
    const selectedOption = this.portingContractHandlingOptions.find(
        option => option.value === this.data.portingContractHandling
    );

    return selectedOption ? selectedOption.label : this.portingContractHandlingOptions[0];
  }

  public dateValueChanged(portingWishDate: string) {
    this.data.portingWishDate = portingWishDate;
  }

  public simNumberSelected(value: any) {
    this.data.simNumber = value.simNumber;
    this.data.msisdn = value.msisdn;

    this.placeholder = value.simNumber;
  }

  public portingFieldRequired(): boolean {
    return ['ERR_INVALID_PORTING_REQUEST', 'ERR_PORTING_REQUEST_FAILED'].includes(this.payloadData.odidoMobileProvisioningErrorCode);
  }

  public asyncFind(query: string) {
    if (this.timer) {
      clearTimeout(this.timer);
    }

    if (query.search(/\+/g) !== -1) {
      query = query.replace(/\+/g, '');
    }

    if (query.length >= 4) {
      const url = '/-/trade/api/aloha.simcardsearch';

      const requestData = {
        type: this.payloadData.searchType,
        provider: this.payloadData.searchProvider,
        partnerCode: this.payloadData.partnerCode,
        customerId: this.payloadData.customerId,
        contains: query,
      };

      this.timer = setTimeout(() => {
        axios
            .post(url, requestData)
            .then(
                (response: any) => {
                  if (response.data.length !== 0) {
                    this.options = response.data.map((simNumber: any) => {
                      return {
                        msisdn: simNumber.number,
                        simNumber: simNumber.iccid,
                        expiryDate: simNumber.expiryDate,
                      };
                    });
                  }
                },
            )
      }, 1000);
    }
  }

    public save() {
      // @ts-ignore-next-line
      this.$v.data.$touch();

      const requestPayload = {
        orderLineId: this.payloadData.orderLineId,
        simNumber: this.data.simNumber,
        msisdn: this.data.msisdn,
        customerNumber: this.data.customerNumber,
        msisdnToPort: this.data.msisdnToPort,
        portingWishDate: this.data.portingWishDate,
        portingContractHandling: this.data.portingContractHandling,
      };

      if (!this.$v.$invalid) {
        this.$emit('setLoad', true);
        axios.post('/-/trade/api/mobile.order.edit.provisioningDetails', requestPayload).then(
          (response: any) => {
            deanDialogBus.$emit('saved');
            this.$toast(this.$store.state.main.notification.messages.dataSaved);
            this.close();
          },
          (error: any) => {
            const errorResponse = error.response.data;
            const errorCode: string | null = getErrorCodeFromResponse(errorResponse);

            let errorMessage: string | null = null;

            switch (errorCode) {
              case 'ERR_EDIT_PROVISIONING_DETAILS_FORBIDDEN':
                errorMessage = 'Bewerkingen zijn alleen toegestaan wanneer de provisioning van de mobiele orderregel is mislukt.';
                break;
              case 'ERR_SIM_CARD_DETAILS_EDIT_NOT_ALLOWED':
                errorMessage = 'U mag simkaartgegevens niet bewerken omdat er geen provisioning fouten zijn met betrekking tot de activering van de simkaart.';
                break;
              case 'ERR_PORTING_DETAILS_EDIT_NOT_ALLOWED':
                errorMessage = 'U mag de porteringsdetails niet bewerken omdat er geen mislukte porteringsaanvraag is.';
                break;
              case 'ERR_SIM_CARD_ATTACHED':
                errorMessage = 'Simkaart is al gekoppeld aan een andere orderregel.';
                break;
              case 'ERR_SELECTED_SIM_NUMBER_NOT_FOUND':
                errorMessage = 'Geselecteerd simnummer niet gevonden.';
                break;
              case 'ERR_SELECTED_MSISDN_NOT_BELONG_TO_SIM_NUMBER':
                errorMessage = 'Geselecteerde msisdn behoort niet tot het simnummer.';
                break;
            }

            if (errorMessage) {
              this.$toast(validationMessage(errorMessage));
            } else {
              this.$toast(this.$store.state.main.notification.messages.couldNotSendData);
            }
          },
        ).finally(() => {
          this.$emit('setLoad', false);
        });
      } else {
        this.$toast(createNotificationFromData(this.$v.data));
      }
    }

    public created() {
      this.$emit('setLoad', false);
    }
  }
</script>

<style lang="scss" scoped>
// IMPORT
@import '~@deanone/dean-components/src/scss/vars';

.multiselect-wrapper {
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0 10px;

  :deep(.multiselect__option--highlight) {
    background: var(--color-primary, $color-primary);
  }
}

:deep(.dialog .dean-dialog-container) {
  width: 600px;
}

:deep(.dean-dialog-content .dean-dialog-slot) {
  overflow-y: visible;
}

.input-label {
  padding-left: 21px;
}
</style>

